<template>
  <div class="live-page">
    <component v-bind:is="currentGame"></component>
  </div>
</template>

<script>
import DotaLive from './dotaLive.vue'
import LolLive from './lolLive.vue'
import CsgoLive from './csgoLive.vue'
import KogLive from './kogLive.vue'

export default {
  name: 'GamingLivePage',
  data() {
    return {}
  },
  components: {
    DotaLive,
    LolLive,
    CsgoLive,
    KogLive
  },
  computed: {
    currentGame() {
      let component = DotaLive
      switch ((this.$route.params.type || '').toLowerCase()) {
        case 'dota2':
          component = DotaLive
          break;
        case 'lol':
          component = LolLive
          break;
        case 'csgo':
          component = CsgoLive
          break;
        case 'kog':
          component = KogLive
          break;
        default:
          break;
      }
      return component
    }
  },
  methods: {},
  mounted() {
    $(".haed_gaming").addClass("nuxt-link-exact-active");
    $("footer").show();
  },
  metaInfo() {
    return {
      script: [
        {
          src: "/static/js/f-chat.js",
        }
      ],
      link: [
        {
          rel: "stylesheet",
          href: "//static.fly2a.com/static/lib/chat/css/jquery-sinaEmotion-2.1.0.min.css",
        },
        {
          rel: "stylesheet",
          href: "//static.fly2a.com/static/lib/chat/css/style.css",
        },
      ],
    };
  },
}
</script>

<style lang="less" scoped></style>
